import request from 'utils/RequestManager';

import config from '../../../../../config';
import {constructTableRequestParams} from "../../../../../utils/TableUtils";

const backendURL = config.BACKEND_HOST;

export default function getHistoryPage(filters = {}, pageable = {}) {
    const adjustedFilters = { ...filters };

    const params = constructTableRequestParams(adjustedFilters,pageable);

    return request({
    method: 'GET',
    baseURL: backendURL,
    url: '/history',
    params,
  })
    .then(response => response.data);
}


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/api.js